// extracted by mini-css-extract-plugin
module.exports = {"nextVideoContainer":"NextVideo_nextVideoContainer___a1Vn","nextButton":"NextVideo_nextButton__1WS5p"};